export class RtUser {
	id: string;
	name: string;
	email: string;
}
